import { render, staticRenderFns } from "./Layout4.vue?vue&type=template&id=0ac3bcbc&scoped=true&"
import script from "./Layout4.vue?vue&type=script&lang=js&"
export * from "./Layout4.vue?vue&type=script&lang=js&"
import style0 from "./Layout4.vue?vue&type=style&index=0&id=0ac3bcbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3bcbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
